import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, TextField, Typography } from '@mui/material';
import { black500 } from '@ui/constants/color';
import React, { useEffect, useState } from 'react';
export const QTextArea = ({ rows = 10, placeholder, customPlaceholder, bgColor = 'contained', errormsg, disabled = false, value = '', label = '', onChange }) => {
    const [isTyping, setIsTyping] = useState(false);
    const [inputValue, setInputValue] = useState(value);
    useEffect(() => {
        setInputValue(value);
        setIsTyping(value !== '');
    }, [value]);
    const handleInputChange = (event) => {
        const newValue = event.target.value;
        setInputValue(newValue);
        setIsTyping(newValue !== '');
        if (onChange) {
            onChange(newValue);
        }
    };
    const handleTextAreaClick = () => {
        setIsTyping(true);
    };
    return (_jsxs(_Fragment, { children: [label && (_jsx(Typography, { variant: 'subtitle2', color: black500, children: label })), _jsxs(Box, { position: 'relative', width: '100%', height: 'auto', sx: {
                    borderRadius: '25px',
                    // overflow: 'hidden',
                    border: '1px solid #D7D7D7',
                    background: bgColor === 'contained' ? '#F8F8F8' : 'white'
                }, children: [_jsx(TextField, { multiline: true, variant: 'standard', InputProps: {
                            disableUnderline: true
                        }, placeholder: placeholder, minRows: rows, maxRows: rows, value: inputValue, disabled: disabled, sx: {
                            width: '100%',
                            resize: 'none',
                            outline: 'none',
                            background: 'transparent',
                            padding: '10px 15px',
                            boxSizing: 'border-box',
                            overflow: 'auto'
                        }, onChange: handleInputChange, onClick: handleTextAreaClick }), errormsg && (_jsx(Box, { sx: { position: 'absolute', bottom: -19, left: 0 }, children: _jsx(Typography, { variant: 'caption', fontWeight: 500, ml: 2, color: '#FF0000', children: errormsg }) }))] })] }));
};
